var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-layout',{attrs:{"fill-screen":true}},[_c('vs-main',[_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }